import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import ErrorBoundary from './shared/ErrorBoundary'
import serverData, { init as initServerData } from './utils/server-data'
import App from './app'

// Styles
import './styles/index.less'

initServerData() // This will initialize the worlready and get the serverData from the dom el.

let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

/*
  Since we're initially rendering our app on the server, instead of calling ReactDOM.render,
  we want to call ReactDOM.hydrate.
  hydrate tells React that you've already created the markup on the server and instead of 
  re-creating it on the client, it should preserve it, but attach any needed event handlers to it.
*/
hydrateRoot(
  root,
  <ErrorBoundary name="app-error">
    <App serverData={serverData} />
  </ErrorBoundary>,
)
